var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcWittAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a2627;}.cls-2{fill:#593838;}.cls-3{fill:#999;}.cls-4{fill:#e2e2e2;}.cls-5{fill:#1e1e1e;}.cls-6{fill:#4c4c4c;}.cls-7{fill:#6d6d6d;}.cls-8{fill:#d88080;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.5 204.97 140.27 172.69 229.5 204.97 211.48 244.86 140 275.52 68.52 244.86 50.5 204.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.26 279.73 15.74 279.73 40.76 224.34 140 174.31 239.24 224.34 264.26 279.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "181.35 257.7 140.27 273.84 98.65 257.7 87.89 201.71 192.1 201.71 181.35 257.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "249.04 184.79 140 223.92 30.95 184.79 38.57 118.02 99.71 64.52 140 59.61 182.22 65.98 242.47 119.06 249.04 184.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "94.1 207.54 44.53 189.37 44.53 165.16 81.89 112.46 140.26 96.17 168.09 145.04 94.1 207.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "187.51 207.67 237.08 189.49 237.08 165.29 199.73 112.59 141.35 96.3 113.52 145.17 187.51 207.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.95 136.17 154.7 123.26 140.51 137.79 125.75 122.67 79.49 135.58 54.75 170 48.3 190.98 105.31 213.03 139.97 175.95 175.13 213.62 232.15 191.03 225.69 170.59 200.95 136.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "182.47 212.78 140.04 223.77 97.62 212.78 106.31 180.38 140.04 165.09 174.23 180.84 182.47 212.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "148.88 118.68 140.27 165.16 131.66 118.68 130.05 66.19 140.54 59.74 150.49 66.19 148.88 118.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "154.06 217.83 140 221.1 125.94 217.83 124.78 199.67 140.28 193.13 155.22 199.67 154.06 217.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "226.5 123.48 169.41 66.38 221.42 14.61 241.19 31.09 226.5 123.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.05 110.74 180.48 71.17 216.52 35.29 230.23 46.71 220.05 110.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.04 124.69 108.26 67.47 56.14 15.6 36.32 32.11 51.04 124.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "57.51 111.92 97.16 72.27 61.04 36.33 47.31 47.77 57.51 111.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "151.15 162.71 179.54 170.31 202.64 146.39 177.01 151.19 151.15 162.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "129.39 162.71 101 170.31 77.9 146.39 103.53 151.19 129.39 162.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.28 164.87 260.04 86.32 248.87 76.52 235.98 83.64 227.23 162.19 238.24 171.97 251.28 164.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "247.6 128.67 256.43 49.44 252.32 43.51 247.07 48.4 238.25 127.63 242.29 133.56 247.6 128.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.28 164.87 17.53 86.32 28.69 76.52 41.59 83.64 50.34 162.19 39.33 171.97 26.28 164.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "29.91 130.82 21.09 51.66 25.49 45.7 31.03 50.55 39.85 129.72 35.51 135.67 29.91 130.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.12 224 52.2 218.87 65.78 280 16.36 280 41.12 224"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "238.42 224 227.34 218.87 213.76 280 263.18 280 238.42 224"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcWittAvatar);
export default __webpack_public_path__ + "static/media/npc-witt-avatar.b457d247f9d61af099a1f1ec03b192d1.svg";
export { ForwardRef as ReactComponent };